const $glossaryContent = document.querySelector(".glossary-content");
const $glossaryGroups = document.querySelectorAll(".glossary-group")
const $glossaryGroupFilters = document.querySelectorAll(".glossary-link--group");
const $glossaryGroupAllFilter = document.querySelector(".glossary-link--all");

if ($glossaryContent !== null) {
    for (const $filter of $glossaryGroupFilters) {
        $filter.addEventListener("click", (event) => {
            $glossaryGroupAllFilter.classList.remove("glossary-link--active")

            for (const $filter of $glossaryGroupFilters) {
                if ($filter.dataset.target === event.target.dataset.target) {
                    $filter.classList.add("glossary-link--active")
                } else {
                    $filter.classList.remove("glossary-link--active")
                }
            }

            event.target.classList.add('glossary-link--active')

            for (const $group of $glossaryGroups) {
                $group.classList.add("hidden")

                if ('#' + $group.id === event.target.dataset.target) {
                    $group.classList.remove("hidden")
                }
            }
        })
    }

    if ($glossaryGroupAllFilter) {
        $glossaryGroupAllFilter.addEventListener("click", () => {
            for (const $filter of $glossaryGroupFilters) {
                $filter.classList.remove("glossary-link--active")
            }

            $glossaryGroupAllFilter.classList.add("glossary-link--active")

            for (const $group of $glossaryGroups) {
                $group.classList.remove("hidden");
            }
        })
    }
}
